import {Close, Visibility, VisibilityOff} from '@material-ui/icons';
import {Language} from '../../../context/LanguageContext';
import Cookies from 'js-cookie';
import {IconProfile} from '../../../assets';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Switch,
} from '@material-ui/core';
import {styled} from '@mui/material';
import {useCallback, useEffect, useState} from 'react';
import {TextField} from '@mui/material';
import {useUser} from '../../../hooks';
import Swal from 'sweetalert2';

export default function FormUser({type, onClose, data}) {
  const tokens_session = Cookies.get('token');
  const [loading, setLoading] = useState(false);
  const {language, newObj} = Language();
  const {getUserGroupList, createUser, updateUser} = useUser();
  const [userGroupList, setUserGroupList] = useState([]);
  const [payload, setPayload] = useState({
    id: '',
    username: '',
    firstname: '',
    lastname: '',
    phone: '',
    status: false,
    avatar: '',
    avatarPreview: '',
    password: '',
    confirmPassword: '',
    group: [],
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [errorPayload, setErrorPayload] = useState({
    username: false,
    firstname: false,
    lastname: false,
    phone: false,
    password: false,
    confirmPassword: false,
    group: false,
  });
  const MaterialUISwitch = styled(Switch)(({checked}) => ({
    '& .MuiSwitch-thumb': {
      color: checked ? '#68aaff !important' : 'dimgray',
    },
    '& .Mui-checked': {
      color: checked ? '#5a7ba6 !important' : 'dimgray',
    },
    '& .MuiSwitch-track': {
      backgroundColor: checked ? '#5a7ba6 !important' : 'dimgray',
    },
  }));
  const handleChangeInput = (e) => {
    const {name, value} = e.target;
    setPayload((prev) => ({...prev, [name]: value}));
  };
  const handleChangeCheck = (e) => {
    const {name, value, checked} = e.target;
    if (checked) {
      setPayload((prev) => ({...prev, [name]: [...prev[name], value]}));
    } else {
      setPayload((prev) => ({
        ...prev,
        [name]: prev[name].filter((item) => item !== value),
      }));
    }
  };

  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setPayload((prev) => ({
        ...prev,
        avatar: file,
        avatarPreview: reader.result,
      }));
    };
  };

  const handleGetUserGroupList = async (tokens_session) => {
    const {data} = await getUserGroupList(tokens_session, {q: ''});
    setUserGroupList(data.data || []);
  };

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        setLoading(true);
        let tempErrorPayload = {...errorPayload};
        for (const key in errorPayload) {
          if (key === 'group') {
            if (payload[key].length === 0)
              tempErrorPayload = {...tempErrorPayload, [key]: true};
            else tempErrorPayload = {...tempErrorPayload, [key]: false};
          } else {
            if (payload[key])
              tempErrorPayload = {...tempErrorPayload, [key]: false};
            else tempErrorPayload = {...tempErrorPayload, [key]: true};
          }
        }
        setErrorPayload(tempErrorPayload);
        const hasError = Object.values(tempErrorPayload).some(
          (value) => value === true
        );
        if (hasError) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: newObj.PleaseFillInAllRequiredFieldsWord[language],
          });
          setLoading(false);
          return;
        }
        let response = null;
        if (type === 'add') {
          response = await createUser(tokens_session, payload);
          onClose();
          setErrorPayload({
            username: false,
            firstname: false,
            lastname: false,
            phone: false,
            password: false,
            confirmPassword: false,
            group: false,
          });
        } else {
          response = await updateUser(tokens_session, {
            ...payload,
            language: language == 1 ? 'en' : 'my',
          });
          onClose();
          setErrorPayload({
            username: false,
            firstname: false,
            lastname: false,
            phone: false,
            password: false,
            confirmPassword: false,
            group: false,
          });
          if (data.selected.username === data.selected.user.username) {
            data.selected.setRole(response.data.data.usergroup_name);
          }
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
    [tokens_session, payload, type, language, errorPayload]
  );

  useEffect(() => {
    handleGetUserGroupList(tokens_session);
  }, []);
  useEffect(() => {
    if (data?.selected) {
      setPayload((prev) => ({
        ...prev,
        id: data.selected.id,
        firstname: data.selected.firstname,
        lastname: data.selected.lastname,
        username: data.selected.username,
        avatarPreview: data.selected.avatar,
        phone: data.selected.phone,
        status: data.selected.status,
        group: data.selected.usergroup_id,
      }));
      setErrorPayload((prev) => ({
        username: false,
        firstname: false,
        lastname: false,
        phone: false,
        group: false,
      }));
    }
  }, [data?.selected]);

  return (
    <div className='modal_content center add_new_user'>
      <div className='modal_header'>
        <p className='modal_title'>{newObj.UserWord[language]}</p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <form action='POST' className='modal_body ' onSubmit={handleSubmit}>
        <div className='left'>
          <div className='profile'>
            <div className='profile_img'>
              <img
                className='img'
                src={payload.avatarPreview || IconProfile}
                alt='avatar'
              />
              <input
                type='file'
                name='avatar'
                id=''
                accept='avatar/*'
                onChange={handleChangeFile}
              />
            </div>
            {type === 'edit' && (
              <div className='account_status'>
                <p className='account_status_text'>
                  {newObj.AccountStatusWord[language]}
                </p>
                <div className='account_status_toggle'>
                  <p>
                    {payload.status
                      ? newObj.ActiveWord[language]
                      : newObj.InactiveWord[language]}
                  </p>
                  <MaterialUISwitch
                    checked={payload.status}
                    onClick={() =>
                      setPayload((prev) => ({...prev, status: !prev.status}))
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div className='profile_input'>
            {type === 'edit' && (
              <TextField
                className='item'
                type='text'
                variant='outlined'
                label='ID'
                onChange={handleChangeInput}
                value={payload.id}
                disabled
              />
            )}
            <TextField
              className='item'
              type='text'
              variant='outlined'
              label='Username'
              name='username'
              onChange={handleChangeInput}
              value={payload.username}
              disabled={type === 'edit'}
              error={errorPayload.username}
            />
            <TextField
              className='item'
              type='text'
              variant='outlined'
              label='First Name'
              name='firstname'
              onChange={handleChangeInput}
              value={payload.firstname}
              error={errorPayload.firstname}
            />
            <TextField
              className='item'
              type='text'
              variant='outlined'
              label='Last Name'
              name='lastname'
              onChange={handleChangeInput}
              value={payload.lastname}
              error={errorPayload.lastname}
            />
            <TextField
              className='item'
              type='text'
              variant='outlined'
              label='Nombor Telefon'
              name='phone'
              onChange={handleChangeInput}
              value={payload.phone}
              error={errorPayload.phone}
            />
            {type === 'add' && (
              <>
                <FormControl className='item' variant='outlined'>
                  <InputLabel htmlFor='newPass1' error={errorPayload.password}>
                    {newObj.PasswordWord[language]}
                  </InputLabel>
                  <OutlinedInput
                    id='newPass1'
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={() => setShowPassword((prev) => !prev)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge='end'
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label={newObj.PasswordWord[language]}
                    name='password'
                    value={payload.password}
                    onChange={handleChangeInput}
                    autoComplete={showPassword ? 'off' : 'new-password'}
                    error={errorPayload.password}
                  />
                </FormControl>
                <FormControl className='item' variant='outlined'>
                  <InputLabel
                    htmlFor='newPass2'
                    error={errorPayload.confirmPassword}
                  >
                    {newObj.PasswordWord[language]}
                  </InputLabel>
                  <OutlinedInput
                    id='newPass2'
                    type={showPassword2 ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={() => setShowPassword2((prev) => !prev)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge='end'
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    name='confirmPassword'
                    label={newObj.PasswordWord[language]}
                    value={payload.confirmPassword}
                    onChange={handleChangeInput}
                    autoComplete={showPassword2 ? 'off' : 'new-password'}
                    error={errorPayload.confirmPassword}
                  />
                </FormControl>
              </>
            )}
          </div>
        </div>
        <div className='right'>
          <div className='banner_assign_group'>
            <p>{newObj.AssignUserGroupWord[language]}</p>
          </div>
          <div className='list_group_choice'>
            {userGroupList.map((group) => (
              <div className='item_group' key={group.id}>
                <input
                  type='checkbox'
                  name='group'
                  id={group.id}
                  value={group.id}
                  onChange={handleChangeCheck}
                  checked={payload?.group?.includes(group.id)}
                />
                <label htmlFor={group.id}>{group.name}</label>
              </div>
            ))}
          </div>
          <div className='group_access'>
            {userGroupList
              .filter((group) => payload?.group?.includes(group.id))
              .map((group) => (
                <div className='item_group' key={group.id}>
                  <p>Name: {group.name}</p>
                  <span>Authority: {group.authority.join(', ')}</span>
                </div>
              ))}
          </div>
          {errorPayload.group && (
            <>
              <p style={{color: '#ff0000', marginBottom: '20px'}}>
                Please select at least one group
              </p>
              <p style={{color: '#ff0000'}}>
                {newObj.PleaseFillInAllRequiredFieldsWord[language]}
              </p>
            </>
          )}
          <div className='modal_flexible_btn_ctr'>
            <button type='submit' disabled={loading}>
              {newObj.SaveWord[language]}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
